import { loadRemoteEntry } from '@angular-architects/module-federation';

import { environment } from './environments/environment';

Promise.all([
  loadRemoteEntry({
    type: 'module',
    remoteEntry: `${environment.builderClientUrl}/remoteEntry.js`,
  })
])
  .catch(err => { console.error(err); })
  .then(_ => import('./bootstrap'))
  .catch(err => { console.error(err); });
